export const ROOM_GET_MULTIPLE =  "ROOM_GET_MULTIPLE"
export const ROOM_GET_ONE =  "ROOM_GET_ONE"
export const ROOM_REGISTER_SUCCESS =  "ROOM_REGISTER_SUCCESS"
export const ROOM_REGISTER_FAIL =  "ROOM_REGISTER_FAIL"
export const ROOM_LOADING =  "ROOM_LOADING"
export const ROOM_LOADING_ERROR =  "ROOM_LOADING_ERROR"
export const ROOM_ACTIVATE_FAIL =  "ROOM_ACTIVATE_FAIL"
export const ROOM_ACTIVATE_SUCCESS =  "ROOM_ACTIVATE_SUCCESS"
export const ROOM_UPDATE_SUCCESS =  "ROOM_UPDATE_SUCCESS"
export const ROOM_UPDATE_FAIL =  "ROOM_UPDATE_FAIL"
export const ROOM_DELETE_SUCCESS =  "ROOM_DELETE_SUCCESS"
export const ROOM_DELETE_FAIL =  "ROOM_DELETE_FAIL"
export const ROOM_EDIT =  "ROOM_EDIT"